// CareerCenters/index.jsx — the career centre page ("/career-centers").
// Rebuilt on the home page's design system: it carries .home-page so the
// palette, type scale and primitives come from homePage.css, the same way
// the job seeker page does.
//
// Order: the alumni banner, hero, school logos, the four platform rows, the
// customer spotlight, the IT review block (standards and security in one
// grid), the AI trust block, the three partnership rows, conferences and
// sponsors, what we publish, and the booking form.
import { Link } from "react-router-dom";
import CcHero from "./CcHero/CcHero";
import CcSchools from "./CcSchools/CcSchools";
import CcPillars from "./CcPillars/CcPillars";
import CcSpotlight from "./CcSpotlight/CcSpotlight";
import CcCompliance from "./CcCompliance/CcCompliance";
import CcTrust from "./CcTrust/CcTrust";
import CcPartnership from "./CcPartnership/CcPartnership";
import CcSessions from "./CcSessions/CcSessions";
import CcResources from "./CcResources/CcResources";
import CcBook from "./CcBook/CcBook";
import Seo from "../../seo/Seo";
import ccHeroPhoto from "../../assets/career-center-home.webp";
import "../HomePage/homePage.css";
import "./careerCenters.css";

const AlumniBanner = () => (
  <div className="cc-banner">
    <div className="home-container cc-banner-inner">
      <span className="cc-banner-badge">New</span>
      <p className="cc-banner-text">
        Alumni engagement is coming to RAIN. Replacing PeopleGrove or Graduway?
      </p>
      <Link to="/alumni" className="cc-banner-link">
        Let&rsquo;s talk
      </Link>
    </div>
  </div>
);

const CareerCentersPage = () => (
  <div className="home-page cc-page">
    <Seo path="/career-centers" preloadImage={ccHeroPhoto} />
    <AlumniBanner />
    <CcHero />
    <CcSchools />
    <CcPillars />
    <CcSpotlight />
    <CcCompliance />
    <CcTrust />
    <CcPartnership />
    <CcSessions />
    <CcResources />
    <CcBook />
  </div>
);

export default CareerCentersPage;
